import { PageHeader } from '@ver-uds/react';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SkipNav } from '@ver-uds/uswds-react';
import Messages from '../../components/message-center/messages.component';

export default function MessageCenter() {
  return (
    <>
      <Helmet>
        <title>SAVE - Message Center</title>
      </Helmet>
      <SkipNav.MainContent>
        <PageHeader>Message Center</PageHeader>
        <div className="grid-container">
          <Messages />
        </div>
      </SkipNav.MainContent>
    </>
  );
}
